export let HttpStatus;

(function (HttpStatus) {
  HttpStatus["Fetching"] = "FETCHING";
  HttpStatus["Success"] = "SUCCESS";
  HttpStatus["Error"] = "ERROR";
})(HttpStatus || (HttpStatus = {}));